import { Box, Tooltip, useTheme } from '@mui/material';
import { SelectionChip } from '../../components/ui/SelectionChip';
import { UsersIcon } from '../../components/ui/icons';
import { tagBackground, tagColor } from './tagColors';

export function TagSelectionChip({
  label,
  tagId,
  shared = false,
  onRemove,
}: {
  label: string;
  tagId?: string;
  shared?: boolean;
  onRemove?: () => void;
}) {
  const theme = useTheme();
  return (
    <SelectionChip
      label={label}
      onRemove={onRemove}
      tone={
        tagId
          ? {
              foreground: tagColor(tagId, theme.palette.mode),
              background: tagBackground(tagId, theme.palette.mode),
            }
          : undefined
      }
      adornment={
        shared ? (
          <Tooltip title="Shared">
            <Box
              component="span"
              role="img"
              aria-label="Shared"
              sx={{ display: 'inline-flex' }}
            >
              <UsersIcon sx={{ fontSize: 18 }} />
            </Box>
          </Tooltip>
        ) : undefined
      }
    />
  );
}
